import { JourneyNode, JourneyEdge } from '../types/journey-nodes'
import { calculateELKLayout, applyELKLayout, applyELKEdgeRouting } from './elk-pipeline'
import { DEFAULT_ELK_CONFIG } from './elk-config'
import { StepType } from '@pushly/models/lib/enums/journeys'

export const positionNodes = async (nodes: JourneyNode[], edges: JourneyEdge[]): Promise<{ nodes: JourneyNode[]; edges: JourneyEdge[] }> => {
    // Validate we have a trigger node
    const triggerNode = nodes.find((n) => n.data.step.type === StepType.TRIGGER)
    if (!triggerNode) {
        return { nodes: [], edges }
    }

    // Check if nodes have been measured by React Flow
    // If not all nodes have measurements, we'll use defaults but log a warning
    const allNodesMeasured = nodes.every(n => n.measured?.width && n.measured?.height)

    if (!allNodesMeasured) {
        // Nodes not yet measured — ELK will use default dimensions
    }

    // Calculate layout using ELK (returns both positions and edge routing)
    const { positions, edgeRouting, portPositions } = await calculateELKLayout(nodes, edges, DEFAULT_ELK_CONFIG)

    // Apply ELK-computed positions to nodes (includes port positions for split steps)
    const positionedNodes = applyELKLayout(nodes, positions, portPositions)

    // Apply ELK-computed edge routing to split edges
    const routedEdges = applyELKEdgeRouting(edges, edgeRouting, positions)

    return { nodes: positionedNodes, edges: routedEdges }
}
